<template>
<div>
    <b-card no-body border-variant="danger" class="marginal">
      <b-card-header header-bg-variant="danger" header-text-variant="white" class="text-center">Alert</b-card-header>
      <b-card-body>
      <b-form @submit.prevent="onSubmit">
        <b-form-group id="videoUuidd"
                      label="Video:"
                      label-for="videoUuidd">
        <b-form-select ref="videoselect" v-model="form.video" :options="videoOptions" class="mb-3" :disabled="disableSelect" />
        </b-form-group>

        <b-form-group id="comment"
                      label="Comment:"
                      label-for="comments">
            <b-form-textarea
                id="comments"
                v-model="form.comments"
                placeholder="Enter a description of the problem..."
                rows="3"
                max-rows="6"
                ></b-form-textarea>
        </b-form-group>
        <b-row class="marginaltop">
        <div class="col-md-4"></div>
        <b-btn type="submit" variant="danger" class="col-md-4">Send alert to QUANTEEC</b-btn>
                </b-row>
        <b-row v-if="isRequestLoading" class="marginal">
          <div class="col-6"></div>
          <fade-loader color="red"></fade-loader>
          </b-row>

      </b-form>
            
      </b-card-body>
    </b-card>
    <b-modal ref="myModalRef" hide-footer hide-header>
      <div v-if="modalInfos">
      <div class="d-block text-center">
          Success
      </div>
        <p class="marginaltop">An alert has been sent to Quanteec team.</p>
        <b-btn class="mt-3" variant="primary" block @click="hideModal">OK</b-btn>
      </div>

      <div v-if="!modalInfos">
      <div class="d-block text-center">
          Error
      </div>
        <p class="marginaltop">An error occured during the alert. Please retry or send a mail to contact@quanteec.com.</p>
              <b-btn class="mt-3" variant="danger" block @click="hideModal">OK</b-btn>
      </div>

    </b-modal>
  </div>
</template>

<script>
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import VideoService from '@/services/video.service';
var videoService = new VideoService();
import AlertService from '@/services/alert.service';
var alertService = new AlertService();

let globalText = 'Global problem';

export default {
  name: 'AlertForm',
  components: {
    'FadeLoader': FadeLoader
  },
  data: function() {
    return {
        uuid: '',
        disableSelect: false,
      form: {
          video: {title: globalText},
          client: '',
          comments: ''
      },
      videoOptions: [{value: {title: globalText}, text: globalText}],
      modalInfos: true,
      isRequestLoading: false
    }
  },
  mounted: function() {
    this.uuid = this.$route.params["uuid"] || null;
    this.loadVideos();
  },
  methods: {
    onSubmit:function() {
        this.form.client = this.$auth.getMyUser().email;
        this.isRequestLoading = true;
        alertService.postAlert(this.form, this.$auth.token()).then((response) => {
            this.isRequestLoading = false;
            this.modalInfos = true;
            this.form.comments = '';
            this.showModal();
        }).catch((e) => {
          console.log(e);
          this.isRequestLoading = false;
          this.modalInfos = false;
          this.showModal();
        })
    },
    loadVideos: function () {
      let self = this;
      videoService.getVideosForClient(this.$auth.token()).then((videos) =>{
          self.videoOptions = [{value: {title: globalText}, text: globalText}]
            for (var video of videos) {
                if (self.uuid !== null && self.uuid === video.uuid) {
                    this.disableSelect = true;
                    self.form.video = video
                }
                self.videoOptions.push({value: video, text: video.title});
            }
      }).catch((err) => {
            console.log(err)
      });
    },
    showModal () {
      this.$refs.myModalRef.show();
    },
    hideModal () {
      this.$refs.myModalRef.hide();
      if (this.modalInfos) {
        this.$router.push("/");
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
